import React, { useState } from 'react';
import { SpheraTooltip } from "@sphera-cloud/component-ui-reactjs";
import { GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { Grid, GridColumn as Column, GridColumnMenuWrapper } from "@progress/kendo-react-grid";
import dateFormats from "../../Data/dateFormats.json";
import CustomerPortalLoginHistoryGridColumns from "../../Data/CustomerPortalLoginHistoryGridColumns.json";
import { LoadingPanel } from '../LoadingPanel';
import { TextCell } from './Cell/TextCell';
import { CustomColumnMenu } from "../CustomColumnMenu";
import { ColumnSelectButton } from "../ColumnSelectButton";

export function CustomerPortalLoginHistoryGrid(props) {
    const [dateFormat, setdateFormat] = React.useState("{0:dd/MM/yyyy hh:mm a}");
    const [dateFormatFilter, setdateFormatFilter] = React.useState("dd/MM/yyyy hh:mm a");
    const [shortDateFormatFilter, setshortDateFormatFilter] = React.useState("dd/MM/yyyy");
    const handleColumnSubmit = (columns) => {
        let newcolumns = props.onColumnsSubmit(columns);
        props.setStateColumns(newcolumns);
    }

    const filterOperators = {
        'text': [
            { text: 'grid.filterEqOperator', operator: 'eq' },
            { text: 'grid.filterNotEqOperator', operator: 'neq' },
            { text: 'grid.filterStartsWithOperator', operator: 'sw' },
            { text: 'grid.filterIsEmptyOperator', operator: 'e' },
            { text: 'grid.filterIsNotEmptyOperator', operator: 'ne' }
        ],
        'numeric': [
            { text: 'grid.filterEqOperator', operator: 'eq' },
            { text: 'grid.filterNotEqOperator', operator: 'neq' },
            { text: 'grid.filterGteOperator', operator: 'gte' },
            { text: 'grid.filterGtOperator', operator: 'gt' },
            { text: 'grid.filterLteOperator', operator: 'lte' },
            { text: 'grid.filterLtOperator', operator: 'lt' },
            { text: 'grid.filterIsNullOperator', operator: 'isnull' },
            { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
        ],
        'date': [
            { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
            { text: 'grid.filterAfterOperator', operator: 'gt' },
            { text: 'grid.filterBeforeOperator', operator: 'lt' },
            { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' }
        ],
        'boolean': [
            { text: 'grid.filterEqOperator', operator: 'eq' }
        ]
    };

    const linkClick = () => { };

    React.useEffect(() => {
        if (props.dateFormatId != null) {
            let format = dateFormats.find(x => x.value === props.dateFormatId);
            if (format != null) {
                setdateFormat("{0:" + format.text + " hh:mm a}");
                setdateFormatFilter(format.text + " hh:mm a");
                setshortDateFormatFilter(format.text);
            }
        }
    }, [props.dateFormatId]);

    return (
        <div style={{ height: 'calc(100vh - 375px)', minHeight: '300px' }}>
            <ColumnSelectButton open={props.showColumnSelect} setopen={props.setshowColumnSelect} onColumnsSubmit={handleColumnSubmit} originalColumns={CustomerPortalLoginHistoryGridColumns} columns={props.stateColumns} setStateColumns={props.setStateColumns} localizations={props.localizations} />
            <Grid
                className="sphera-grid"
                style={{
                    height: '100%',
                    width: '100%'
                }}
                data={props.CustomerPortalLoginHistoryData}
                {...props.dataStateBackend}
                sortable={true}
                reorderable={true}
                resizable={true}
                onColumnReorder={props.columnReorder}
                onColumnResize={props.columnResize}
                filterOperators={filterOperators}
                scrollable="scrollable"
                pageable={{
                    buttonCount: 4,
                    pageSizes: [25, 50, 100]
                }}
                onDataStateChange={props.onDataStateChange}
                onPageChange={props.onPageChange}
                onFilterChange={props.onFilterChange}
                onSortChange={props.onSortChange}
            >
                {props.stateColumns.map(
                    (column, idx) =>
                        column.show && (
                            <Column
                                key={idx}
                                cell={(props2) =>
                                    <TextCell field={column.field}
                                        isLink={column.isLink}
                                        searchedPhrase=""
                                        linkClick={linkClick}
                                        clickId={props2.dataItem.materialId}
                                        DisplayValue={column.AdjustTimezone ? props2.dataItem[column.field + "Display"] : props2.dataItem[column.field]}
                                        customer={props.customer}
                                        isDate={column.isDate}
                                        adjustTimezone={column.AdjustTimezone}
                                    />
                                }
                                field={column.field}
                                title={props.localizations[column.title]}
                                filter={column.filter}
                                format={dateFormat}
                                width={column.width}
                                minResizableWidth={100}
                                headerClassName={GridColumnMenuFilter.active(column.field, props.dataStateBackend.filter) ? 'active' : ''}
                                headerCell={(props2) =>
                                    <span className="k-cell-inner">
                                        <span className="k-link" onClick={props2.onClick} onKeyDown={(e) => { if (e.code === "Enter") props2.onClick(); }}>
                                            <SpheraTooltip anchor="target" position="top" title={props.localizations[column.title]} >
                                                <span className="k-column-title">{props.localizations[column.title]}</span>
                                            </SpheraTooltip>
                                            {props2.children}
                                        </span>
                                        <GridColumnMenuWrapper
                                            {...props2.columnMenuWrapperProps}
                                        ></GridColumnMenuWrapper>
                                    </span>
                                }
                                columnMenu={(props2) => (
                                    <CustomColumnMenu {...props2} data={column.field === "username" ? props.portalUsers : props.portals} checkboxFilter={column.checkboxFilter} columns={CustomerPortalLoginHistoryGridColumns} useDateFilter={column.isDate} dateFormatFilter={dateFormatFilter} />
                                )}
                            />
                        )
                )}
            </Grid>
            {props.pending && <LoadingPanel localizations={props.localizations} />}
        </div>
    );
}